module.exports = "<app-calendar-style [agenda]=\"agenda\"></app-calendar-style>\n<div #calendar id=\"calendar\">\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/calendar/user-calendar/usercalendar.html
// module id = ./src/app/calendar/user-calendar/usercalendar.html
// module chunks = main